import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Grade() {
  let navigate = useNavigate();

  const [listeGrade, setListGrade] = useState([]);
  const token = localStorage.getItem('accessToken');

  useEffect(() => {
    axios
      .get('/grade', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setListGrade(res.data);
      });

  }, []);

  return (
    <div className="container mt-5 pt-3 ">
      <div>Liste Grade</div>
      <Link to="/creatGrade" className="btn btn-primary">
        Nouveau Grade
      </Link>
      <table className="table table-border table-sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Grade Terre</th>
            <th>Libelle</th>
            <th>Grade Air</th>
            <th>Libellé Grade Air</th>
            <th>Grade Mer</th>
            <th>Libellé Grade Mer</th>
            <th>Année retraite</th>
          </tr>
        </thead>
        <tbody>
          {listeGrade.map((grade, key) => {
            return (
              <tr key={key}>
                <td> {grade.id} </td>
                <td> {grade.name} </td>
                <td> {grade.libelle} </td>
                <th>{grade.gradeair}</th>
                <th>{grade.libellegradeair}</th>
                <th>{grade.grademer}</th>
                <th>{grade.libellegrademer}</th>
                <th>{grade.anneeretraite}</th>
                <i className="fa fa-edit" onClick={() => navigate(`/grade/${grade.id}/edit`)}></i>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Grade;
